import { useQuery } from '@tanstack/react-query'
import { publicApi } from '@/lib/api'
import { SignatureQueryKey } from '../helpers/signature-query-key'
import { useAccessToken } from '@/features/auth/state/auth'

export function useFetchSignatureByIdTenant(id_tenant?: string) {
  const token = useAccessToken()

  return useQuery({
    queryKey: SignatureQueryKey(id_tenant),
    queryFn: async () => {
      if (!id_tenant) throw new Error('Signature id_tenant is required')
      const { data } = await publicApi.get(`/signatures/empresa/${id_tenant}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      // data aqui já é o array de signatures
      if (Array.isArray(data)) return data
      throw new Error('Invalid signatures response')
    },
    enabled: Boolean(token && id_tenant)
  })
}
